/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Při aktualizaci vaší adresy došlo k chybě. Prosím zkuste znovu.`
};

const da_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl under opdatering af din adresse. Prøv venligst igen.`
};

const de_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Aktualisieren Ihrer Adresse ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`
};

const en_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred while updating your address. Please try again.`
};

const es_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error al actualizar tu dirección. Por favor, inténtalo de nuevo.`
};

const fr_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors de la mise à jour de votre adresse. Veuillez réessayer.`
};

const hu_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a cím frissítése során. Kérjük, próbálkozz újra.`
};

const it_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante l'aggiornamento dell'indirizzo. Riprova.`
};

const nl_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden bij het bijwerken van je adres. Probeer het opnieuw.`
};

const pl_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd podczas aktualizacji adresu. Spróbuj ponownie.`
};

const pt_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro ao atualizar seu endereço. Por favor, tente novamente.`
};

const sv_checkout_update_address_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod vid uppdatering av din adress. Försök igen.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_update_address_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_update_address_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_update_address_error", locale)
	if (locale === "cs") return cs_checkout_update_address_error(inputs)
	if (locale === "da") return da_checkout_update_address_error(inputs)
	if (locale === "de") return de_checkout_update_address_error(inputs)
	if (locale === "en") return en_checkout_update_address_error(inputs)
	if (locale === "es") return es_checkout_update_address_error(inputs)
	if (locale === "fr") return fr_checkout_update_address_error(inputs)
	if (locale === "hu") return hu_checkout_update_address_error(inputs)
	if (locale === "it") return it_checkout_update_address_error(inputs)
	if (locale === "nl") return nl_checkout_update_address_error(inputs)
	if (locale === "pl") return pl_checkout_update_address_error(inputs)
	if (locale === "pt") return pt_checkout_update_address_error(inputs)
	return sv_checkout_update_address_error(inputs)
};
export { checkout_update_address_error as "checkout.update_address_error" }